<template>
  <div>
    <b-modal
      v-model="invoiceGenerationModal.show"
      title="Generar factura"
      size="lg"
      id="bv-modal-example"
      @hidden="resetModal"
      hide-footer
    >
      <div class="d-block">
        <span v-if="invoiceGenerationModal.hasTotalInvoice"
          >El pedido #{{ invoiceGenerationModal.orderId }} ya tiene una factura
          total generada. No es posible generar más facturas.</span
        >
        <span v-else-if="invoiceGenerationModal.invoices.length > 1"
          >El pedido #{{ invoiceGenerationModal.orderId }} ya tiene
          {{ invoiceGenerationModal.invoices.length }} facturas parciales
          generadas. Si lo deseas, puedes generar otra factura parcial.<br />Antes
          de hacerlo, recuerda comprobar que la suma de esta y las anteriores no
          supere el precio total del pedido.</span
        >
        <span v-else-if="invoiceGenerationModal.invoices.length === 1"
          >El pedido #{{ invoiceGenerationModal.orderId }} ya tiene 1 factura
          parcial generada. Si lo deseas, puedes generar otra factura
          parcial.<br />Antes de hacerlo, recuerda comprobar que la suma de esta
          y las anteriores no supere el precio total del pedido.</span
        >
        <span v-else
          >El pedido #{{ invoiceGenerationModal.orderId }} aún no tiene ninguna
          factura generada. <br />¿Qué quieres hacer?</span
        >
      </div>

      <b-row
        class="mt-2 align-items-center"
        v-if="!invoiceGenerationModal.hasTotalInvoice"
      >
        <b-col v-if="!(invoiceGenerationModal.invoices.length > 0)">
          <b-button
            variant="outline-primary"
            block
            @click="generateTotalInvoice()"
            >Generar factura total</b-button
          >
        </b-col>
        <b-col v-if="!(invoiceGenerationModal.invoices.length > 0)" cols="auto"
          >o bien</b-col
        >
        <b-col>
          <b-input-group>
            <b-form-input
              type="text"
              id="amount"
              :value="$v.form.amount.$model.replace('.', ',')"
              @change="setDecimal('amount', $event)"
              :state="validateState('amount')"
              aria-describedby="input-amount-feedback"
              placeholder="123,45"
            ></b-form-input>
            <template #prepend>
              <b-input-group-text>Cantidad (con IVA):</b-input-group-text>
            </template>
            <template #append>
              <b-input-group-text>€</b-input-group-text>
            </template>
          </b-input-group>
          <b-form-invalid-feedback
            :state="validateState('amount')"
            id="input-amount-feedback"
            >Este campo debe ser un número positivo.</b-form-invalid-feedback
          >

          <b-button
            class="mt-2"
            variant="outline-primary"
            @click="generatePartialInvoice()"
            block
            >Generar factura parcial</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <OpenOrdersModal
      :readOnly="true"
      :id="null"
      :valDeadlineWorkshopOverride="null"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Ventas</h2>
          <p v-if="locationInfo">
            En este apartado se pueden gestionar las ventas de la tienda de
            {{ locationInfo.name }}.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de ventas</h3>
              <v-server-table
                name="orders"
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    v-b-modal.workshop-date-modal
                    ><b-icon icon="calendar-3" /> Calendario de
                    pedidos</b-button
                  > -->

                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminOrdersEditScreen',
                      params: { id: 'new', location: location },
                    }"
                    >Nueva venta</b-button
                  >
                  <!-- <b-button
                    variant="outline-primary"
                    @click="refreshTable()"
                    class="ml-3"
                    ><b-icon icon="arrow-clockwise" /> Refrescar</b-button
                  > -->
                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.reference)"
                    @change="toggleCell($event, props.row.reference)"
                  />
                </div>

                <template v-slot:modified_at="props">
                  <span>{{ props.row.modified_at }}</span>
                </template>

                <template v-slot:customer="props">
                  <span>{{
                    props.row.customer_name
                      ? props.row.customer_name
                      : 'Genérico'
                  }}</span>
                </template>

                <template v-slot:abbr_product_names="props">
                  <div
                    :key="i"
                    v-for="(abbr_product_name, i) in props.row
                      .abbr_product_names"
                  >
                    {{
                      abbr_product_name['qty'] +
                      ' x ' +
                      abbr_product_name['name']
                    }}
                  </div>
                </template>

                <template v-slot:created_at="props">
                  <span>{{ props.row.created_at }}</span>
                </template>

                <template v-slot:total_price="props">
                  <span>{{ props.row.total_price }} €</span>
                </template>

                <template v-slot:created_by="props">
                  <span>{{
                    props.row.created_by.map((x) => x.first_name).join(', ')
                  }}</span>
                </template>

                <template v-slot:refund_set="props">
                  <span>{{ props.row.refund_set.length ? 'Sí' : '-' }}</span>
                </template>

                <template v-slot:status="props">
                  <span>{{ props.row.status | formatStatus }}</span>
                </template>

                <template v-slot:quote_id="props">
                  <div
                    v-if="
                      props.row.orderstatushistory_set.length === 1 &&
                      props.row.orderstatushistory_set[0].status === 'Delivered'
                    "
                  >
                    Venta en tienda (<b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >)
                  </div>
                  <div v-else-if="props.row.quote_id">
                    <b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >
                  </div>
                  <div v-else>Venta web</div>
                </template>

                <template v-slot:invoice="props">
                  <span>{{ props.row.invoice ? props.row.invoice : '-' }}</span>
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminOrdersEditScreen',
                      params: {
                        id: props.row.id.toString(),
                        location: location,
                      },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon icon="pencil" aria-hidden="true" />
                  </b-button>

                  <b-button
                    :to="{
                      name: 'AdminOrdersEditScreen',
                      params: {
                        id: props.row.id.toString(),
                        location: location,
                        isReturn: true,
                      },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Devolución
                  </b-button>

                  <!-- <b-button
                    @click="downloadOrder(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon
                      icon="file-earmark-arrow-down"
                      aria-hidden="true"
                    ></b-icon>
                    Pedido
                  </b-button> -->

                  <span
                    :id="'btn-' + props.row.id"
                    class="d-inline-block"
                    tabindex="0"
                  >
                    <b-button
                      @click="
                        downloadOrderLegalBtn(props.row.id, props.row.invoice)
                      "
                      :id="'btn-' + props.row.id"
                      size="sm"
                      variant="outline-primary"
                      class="mr-2"
                      :disabled="
                        !props.row.billing_address_id ||
                        props.row.billing_address_company.company_id === null ||
                        props.row.billing_address_company.company_id === ''
                      "
                    >
                      <!-- {{
                      props.row.invoice
                        ? 'Factura (' + props.row.invoice + ')'
                        : 'Factura'
                    }} -->
                      Generar factura
                    </b-button>
                  </span>

                  <b-tooltip
                    placement="left"
                    v-if="
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                    "
                    :target="'btn-' + props.row.id"
                    triggers="hover"
                  >
                    {{
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                        ? 'Debe constar una dirección de facturación y esta debe contener un identificador de empresa/autónomo (CIF)'
                        : ''
                    }}
                  </b-tooltip>
                  <!-- <b-button
                    @click="downloadOrderWorkshop(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon icon="gear-fill" aria-hidden="true"></b-icon> Orden
                    de taller</b-button
                  > -->

                  <b-button
                    @click="removeOrder(props.row.id)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    ><b-icon icon="trash" aria-hidden="true" />
                  </b-button>
                </template>

                <template v-slot:invoice="props">
                  <div v-if="props.row.invoice">
                    <b-row :key="inv.id" v-for="inv in props.row.invoice">
                      <b-col cols="12">
                        <b-button
                          block
                          @click="downloadInvoice(inv.id)"
                          :id="'btn-' + props.row.id"
                          size="sm"
                          class="mb-1"
                          variant="outline-primary"
                          ><b-icon
                            icon="file-earmark-arrow-down"
                            aria-hidden="true"
                          ></b-icon>
                          <!-- {{
                      props.row.invoice
                        ? 'Factura (' + props.row.invoice + ')'
                        : 'Factura'
                    }} -->
                          {{ inv.id }} ({{
                            inv.is_partial
                              ? `Parcial ${inv.amount} €`
                              : 'Total'
                          }})
                        </b-button>
                      </b-col></b-row
                    >
                  </div>
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';
import { uris, actions } from '@/admin/api.js';
import OpenOrdersModal from '@/admin/components/orders/OpenOrdersModal.vue';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminOrdersScreen',
  props: ['location'],
  components: { OpenOrdersModal },
  validations() {
    let rules = {
      amount: {
        required,
        minValue: minValue(1.0),
        decimal,
      },
    };
    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });
    return {
      form: rules,
    };
  },
  data() {
    return {
      form: {
        amount: '',
      },
      invoiceGenerationModal: {
        show: false,
        orderId: 0,
        invoices: [],
      },
      table: {
        url: uris.ordersByLocationURI(this.location),
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'id',
          'customer',
          'abbr_product_names',
          'created_at',
          'total_price',
          'created_by',
          'refund_set',

          'invoice',
          'actions',
        ],
        options: {
          rowClassCallback: function (row) {
            return row.status === 'Received' ? 'bg-light-warning' : '';
          },

          saveState: true,
          sortable: ['modified_at', 'created_at'],
          headings: {
            invoice: 'Facturas',
            customer: 'Cliente',
            abbr_product_names: 'Productos',
            modified_at: 'Modificado',
            created_at: 'Fecha',
            total_price: 'Total (con IVA)',
            created_by: 'Creado por',
            id: '# Venta',
            actions: 'Acciones',
            refund_set: 'Devoluciones',
          },
        },
      },
      sharedState: store.state,
      locationInfo: null,
    };
  },
  created() {
    Promise.all([actions.getLocationById(this.location)]).then((x) => {
      this.locationInfo = x[0].data;
    });

    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        Promise.all([actions.getLocationById(this.location)]).then((x) => {
          this.locationInfo = x[0].data;
        });

        this.table.url = uris.ordersByLocationURI(this.location);
        // this.$refs.table.refresh();
      }
    );
  },
  filters: {
    formatStatus: function (value) {
      return {
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
    formatDateTime: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    formatCurrency(val) {
      return val.toFixed(2);
    },
  },
  methods: {
    resetModal() {
      this.invoiceGenerationModal.orderId = null;
      this.invoiceGenerationModal.invoices = null;
      this.invoiceGenerationModal.hasTotalInvoice = null;
      this.form.amount = '';
      this.$v.$reset();
    },
    downloadInvoice(invoiceId) {
      actions.downloadInvoice(invoiceId).then((x) => {
        let fileName = 'test.pdf';
        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }
        let blob = new Blob([x.data], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
    },
    generatePartialInvoice() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let data = {
        amount: this.form.amount,
      };
      actions
        .generateInvoicePartial(this.invoiceGenerationModal.orderId, data)
        .then((y) => {
          this.refreshTable();
          const invoiceId = y.data.id;
          this.downloadInvoice(invoiceId);
          this.invoiceGenerationModal.show = false;
        });
    },
    generateTotalInvoice() {
      actions
        .generateInvoiceTotal(this.invoiceGenerationModal.orderId)
        .then((y) => {
          this.refreshTable();
          const invoiceId = y.data.id;
          this.downloadInvoice(invoiceId);
          this.invoiceGenerationModal.show = false;
        });
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    downloadOrder(id) {
      actions.downloadOrder(id).then((x) => {
        let fileName = 'Pedido.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    downloadOrderLegalBtn(orderId, invoices) {
      this.invoiceGenerationModal.show = true;
      this.invoiceGenerationModal.orderId = orderId;
      this.invoiceGenerationModal.invoices = invoices;
      this.invoiceGenerationModal.hasTotalInvoice = invoices.some(
        (x) => x.is_partial === false
      );
      // if (
      //   invoices ||
      //   (!invoices &&
      //     confirm(
      //       '¿Estás seguro que deseas generar una factura para el pedido ' +
      //         orderId +
      //         '?'
      //     ))
      // ) {
      //   actions.downloadOrderLegal(orderId).then((x) => {
      //     let fileName = 'Factura.pdf';
      //     const contentDisposition = x.headers['content-disposition'];
      //     if (contentDisposition) {
      //       const fileNameMatch = contentDisposition.match(/filename=(.+)/);
      //       if (fileNameMatch.length === 2) {
      //         fileName = fileNameMatch[1];
      //       }
      //     }
      //     let blob = new Blob([x.data], { type: 'application/pdf' });
      //     let link = document.createElement('a');
      //     link.href = window.URL.createObjectURL(blob);
      //     link.download = fileName;
      //     link.click();
      //   });
      // }
    },
    downloadOrderWorkshop(id) {
      actions.downloadOrderWorkshop(id).then((x) => {
        let fileName = 'Orden-taller.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    // removeSelected() {
    //   this.table.selected.map((x) => {
    //     this.removeOrder(x);
    //   });
    // },
    removeOrder(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar el pedido número ' + id + '?'
        )
      ) {
        actions.deleteOrder(id).then((x) => {
          this.$refs.table.refresh();
        });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .bg-light-warning {
  background-color: rgba(255, 255, 213, 0.55) !important;
  &:hover {
    color: #212529;
    background-color: rgba(255, 255, 213, 0.95) !important;
  }
}
</style>
